import React from "react";
import styles from "./ReqRow.module.css";
import { dangerousSetInnerHTML } from "../../../../../common/utils";
import { icon, IconComponent, VerticalDivider } from "../../../../../common/components";

export default function ReqRow({ clientRef, content, generatedByAI, id, onClick, selected, style, versionStatus }) {
	const handleIcon = () => {
		if (versionStatus === "NEW") {
			return <IconComponent className={styles.icon} color="var(--blue-500)" icon={icon.faPlusCircle} size="sm" />;
		}
		if (versionStatus === "UPDATED_MINOR") {
			return (
				<IconComponent
					className={styles.icon}
					color="var(--color-keppel)"
					icon={icon.faExclamationTriangle}
					size="sm"
				/>
			);
		}
		if (versionStatus?.includes("UPDATED")) {
			return (
				<IconComponent
					className={styles.icon}
					color="var(--red-500)"
					icon={icon.faExclamationTriangle}
					size="sm"
				/>
			);
		}
		if (versionStatus === "DELETED") {
			return <IconComponent className={styles.icon} color="var(--red-500)" icon={icon.faMinusCircle} size="sm" />;
		}
		return null;
	};
	const className = selected ? `${styles.req_row} ${styles.req_row__selected}` : `${styles.req_row}`;
	return (
		<button className={className} style={style} type="button" onClick={onClick}>
			<div className={styles.req_row__header}>
				<span className={styles.req_row__title}>
					<IconComponent className={styles.requiredIcon} color="var(--red-500)" icon={icon.faAsterisk} />
					{!!id && `REQ_${id}`}
					{generatedByAI && (
						<span className={styles.row__generatedByAiContainer}>
							<VerticalDivider className={styles.row__generatedByAiDivider} />
							<span className={styles.row__generatedByAiIcon}>
								<IconComponent color="var(--blue-500)" icon={icon.faWandMagicSparkles} size="2xs" />
							</span>
						</span>
					)}
					{handleIcon()}
				</span>
				{clientRef && <div className={styles.req_row__ref}>[{clientRef}]</div>}
			</div>
			<p className={styles.req_row__content}>{dangerousSetInnerHTML({ text: content })}</p>
		</button>
	);
}
